import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { postUserMappedSeatsAction } from "../actions";
import { get } from "lodash";

export const useFetchAccountThirdPartySeats = () => {
    const reduxDataForSeats = useSelector((state) =>
        get(state, "app.userMappedSeats.response", "")
    );

    const tenantId = useSelector((state) =>
        get(state, "app.preSignInState.tenantId", "")
    );

    const userId = useSelector((state) =>
        get(state, "app.preSignInData.userId", "")
    );

    const authToken = useSelector((state) =>
        get(state, "app.signInData.authToken", "")
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const fetchSeats = async () => {
            let params = { list: 'all' };
            if (!reduxDataForSeats) {
                try {
                    await dispatch(
                        postUserMappedSeatsAction({ tenantId, authToken, userId, params })
                    ).catch((err) => {
                        console.log(err);
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        };
        fetchSeats();
    }, [reduxDataForSeats]);

    // if (Array.isArray(reduxDataForSeats)) {
    //     return reduxDataForSeats.map(seat => ({ ...seat, isExpired: 1 }));
    // }

    return reduxDataForSeats;
};